import { app } from '../../app.module'
app.component('accountFollower', {
  bindings: {
    accountId: '=',
    snsType: '=',
    accountFollowerConfig: '=',
    followerGraphEmpty: '=',
    selectedPeriodType: '=',
    accountUsername: '=',
  },
  template: require('./account-follower.pug')(),
})
